<template>
  <div class="flex gap-[20px] relative">
    <div
      v-show="$route.name === '/checkout-type'"
      class="relative cursor-pointer w-[32px] h-[32px] md:w-[50px] md:h-[50px] rounded-[5px] flex items-center justify-center"
      :class="{
        'border-[1px] border-primary bg-[#E1E1E1]': isOpenList,
        'bg-background': !isOpenList,
      }"
      @click="toggleList"
    >
      <icon-product-list
        class="text-primary w-[25px] h-[25px] md:w-[32px] md:h-[32px]"
      />
    </div>
    <div
      class="absolute top-[100%] pt-4 right-0 md:right-[55%] z-50 sm:w-[530px] w-[324px]"
      :class="{
        hidden: !isOpenList,
      }"
    >
      <CheckoutProductList />
    </div>
    <router-link
      class="cursor-pointer w-[32px] h-[32px] md:w-[50px] md:h-[50px] bg-background rounded-[5px] flex items-center justify-center"
      :to="{
        name: '/cart',
      }"
    >
      <i-material-symbols-close-rounded
        class="text--md text-[24px] text-primary"
      />
    </router-link>
  </div>
</template>

<script setup>
import {ref} from "vue";
import CheckoutProductList from "@/components/checkout/CheckoutProductList.vue";

const isOpenList = ref(false);

const toggleList = () => {
  isOpenList.value = !isOpenList.value;
};
</script>
